import styles from "./SendButton.module.scss";

export const SendButton = ({ onSubmit }: { onSubmit: () => void }) => {
  return (
    <div onClick={onSubmit} className={styles.sendButton}>
      <span className={`material-symbols-outlined ${styles.sendIcon} `}>
        send
      </span>
    </div>
  );
};
